import { detectContactDetails, blockingKinds, CONTACT_WARNING, CONTACT_KIND_LABELS } from '../lib/contactDetection'

// Shows the "keep contact details off HireIt" notice while someone types
// a phone number, email, social handle or link.
// Default: amber warning only (see CONTACT_MODE in lib/contactDetection.js).
// block: red notice naming what was found — used where saving is refused (Wanted).
export default function ContactWarning({ text, style, block = false }) {
const result = detectContactDetails(text)
if (!result.found) return null
const blocking = block ? blockingKinds(result) : []
if (blocking.length) {
const what = blocking.map(k => (CONTACT_KIND_LABELS[k] || k).toLowerCase()).join(', ')
return (
<div role="alert" className="alert alert-error" style={{ fontSize: 13, marginBottom: 12, ...style }}>
🔒 {CONTACT_WARNING} Please remove the contact details to post (found: {what}).
</div>
)
}
return (
<div role="status" className="alert" style={{ background: 'var(--amber-light)', color: 'var(--amber)', border: '1px solid var(--amber)', fontSize: 13, marginBottom: 12, ...style }}>
🔒 {CONTACT_WARNING}
</div>
)
}
